import React, { useState, useEffect } from 'react';
import {
  Flex,
  Box,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  useMediaQuery,
} from '@chakra-ui/react';
import { GET_FAQ } from '../apollo/queries/GetFaqs';
import { useQuery, useApolloClient } from '@apollo/client';
import Seo from '../components/Seo';
import Layout from '../components/Layout';
import ChakraMarkdown from '../components/ChakraMarkdown';

import { Roboto_Condensed } from 'next/font/google';

// Subsets are really important.
const roboto = Roboto_Condensed({
  weight: '400', // if single weight, otherwise you use array like [400, 500, 700],
  style: 'normal', // if single style, otherwise you use array like ['normal', 'italic']
  subsets: ['latin'],
});

const riderQuestions = [
  {
    question: 'What type of services is Vert providing?',
    answer: `Vert delivers the ultimate eco-friendly Executive Chauffeur Service for airport transfers, business excursions, corporate gatherings, roadshows, wedding occasions, and shopping outings.`,
  },
  {
    question: 'What type of vehicles are available?',
    answer: `The Vert platform currently offers an extended range, fully electric cars, and we're excited to announce that more models will be joining our lineup in the very near future.`,
  },
  {
    question: 'How can I create a Vert account?',
    answer: `Sign up on the Website or simply Download Vert App`,
  },
  {
    question: 'How can I order through Vert?',
    answer: `Simply press on “New Ride”, set your destination and schedule your next order.`,
  },
  {
    question: 'How can I schedule an order through Vert ?',
    answer: `Press on “New Ride” enter the destination and then press on the clock icon. Choose your day and time, confirm and the press “Schedule trip”. We will send you a booking confirmation. We can also view your scheduled ride in Upcoming Trips.`,
  },
  {
    question:
      'Can I book Vert services hourly, daily or for any other specific request?',
    answer: `You can book Vert Services as per your needs. Please get in touch for any specific requests.`,
  },
  {
    question: 'How do I set up my profiles?',
    answer: `You can set up your profiles by pressing “Wallet” on your account. You can customise your Family and Business Profile.`,
  },
  {
    question: 'How do I invite members to my profiles?',
    answer: `On the Wallet section tap on your Profiles and then Members. Once invited you will then be able to allocate Eyes to your members. You can remove members from your profile at any time and the allocated credit will return to your account balance.`,
  },
  {
    question: 'What are Eyes?',
    answer: `Eyes are digital credits that you can purchase through Vert platform. You can use Eyes to pay for you trips, you can distribute Eyes to members of your Family and Business profiles.`,
  },

  {
    question: 'How can I pay with Eyes as a member of a profile?',
    answer: `When Eyes have been allocated to you as a member of a profile you will be able to use the credit by taping “Payment method” and then selecting your member profile you want to pay with`,
  },
  {
    question: 'How can I remove a member’s account from my profile?',
    answer: `You can delete a member’s account by going to Wallet, select View on Members and choose which member you want to remove from your account. The remaining Eyes will return to your overall balance automatically.`,
  },
  {
    question: 'Who is my Vert Chauffeur?',
    answer: `Once your order has been accepted and confirmed, we will be searching for the next available Vert Chauffeur. Once confirmed, you will then receive the information about your Chauffeur and the car allocated for your trip.`,
  },
  {
    question: 'What is Safety as a Standard (SaaS)?',
    answer: `At Vert everything we do has Safety at its core. SaaS is a training program designed to promote, enhance, monitor and audit safety standards, including health, safety, welfare and environment. All our Chauffeurs are going through the SaaS training program before starting to drive for Vert. All Vert Chauffeurs will become SaaS Affiliate Members once completed.
    L2 Drivers Code of Conduct

  Adult Basic Life Support with Automated External Defibrillation

  Covid 19

  Mental Health Awareness

  Sexual Harassment Awareness`,
  },
  {
    question: 'How do I get rated and how can I rate my driver?',
    answer: `For continuous improvement of Vert services, we have developed a differentiated mutual rating system that allows both drivers and riders to rate each other in two areas: service and safety (the two driving forces for us to create the platform).

  When rating for service we allow you to decide, using a 5-star system, to decide how good was the service your driver provided and for them to rate how good of a customer you were.
    
  We also want you to rate each other by the feeling of safety you both had and created on each other during the ride.
    
  This is to help us maintain our service as safe as possible and to educate our users (both riders and drivers) in how they can help us make Vert better every day.
    
  The safety rating scale is based on emoticons that describe and relate to how you felt in the ride: The lowest being report driver, followed by worried, room for improvement and finally in safe hands.
    
  We will ask you to fill a comment box to provide us with more information about the ride, which will be mandatory when you rate that ride with “Room for improvement” or below.
    `,
  },
  {
    question: 'How can I report a driver?',
    answer: `We take your safety very seriously. Therefore, we make it simple for you to tell us how you felt during a ride and to report a driver if you felt unsafe while they drove you. To do so please choose:

  If you are at the end of the ride, please use the “Safety” rating scale and select the “Report Driver” option. Fill the Report User Form with as many details as possible regarding the events that resulted in you reporting the driver and submit it to us.
    
  If you are feeling unsafe during a ride, please tap on the SOS button on the bottom right corner of your screen to activate the panic button. When you activate the panic button, we will send an automatic text to the authorities and other members of the Vert Community to get you help.
    `,
  },
  {
    question: 'What happens if I get reported?',
    answer: `When you get reported by a driver, we will review the reasons submitted in the comments added to the report rider form.

  During the time it takes us to review the issue that caused them to report you, we will suspend both your account and the driver's account.
    
  If we find that you committed gross misconduct that put the driver or other users at risk, we will revoke your access to the Vert platform and system. We may also report you to the competent authorities for further action to be taken.
    `,
  },
  {
    question: 'What is the Panic Button?',
    answer: `Vert is committed to working with other Users and Stakeholders to enhance the safety of those participating in rides through our platform.

  the App contains a Panic Button which allows Users to contact the Emergency Services. When you press the button you can call 112 through the native dialler or activate the Panic Button and the emergency services will be notified. This is only to be used in case of emergency.
    
  MISUSE OF THIS TOOL WILL RESULT IN YOUR ACCOUNT BEING TERMINATED.
    `,
  },
  {
    question: 'How can I share my ride progress?',
    answer: `Once picked up by your Chauffeur you will be able to see the progress of your ride and also share it with others. Press “Share Ride” and select who do you want to share the ride with.`,
  },
  {
    question: 'What can I do if I have experienced a trip issue?',
    answer: `If you have lost or forgot an item or you have experienced an issue of any kind you can go to Past Trips, select the trip and press “Trip issue”. Alternatively, please get in touch. It is very important to report any kind of issue experienced during the trip so it can be dealt with asap.

  `,
  },
];

const driverQuestions = [
  {
    question: 'What do I need to create an account?',
    answer:
      "To create a Vert account, please follow these steps:\n1.Download the Vert Chauffeur App. \n2.Enter your mobile number to receive a verification code. Once validated, you'll be prompted to provide your personal information and car registration details. You'll also need to set a password and agree to our terms and conditions and privacy notice. \n3.Fill in your First Name, Last Name, Gender, and Private Hire Driver License Number. \n4.Upload a clear picture of your ID and a professional photo for your Vert Chauffeur App profile. This profile picture will be visible to clients when you accept jobs through Vert. \n5.Vert will verify all the documents you upload. They will have a status of Pending, Approved, or Rejected. If any document is rejected, you will need to resubmit that specific document. \n6.Once your car documents are verified, your car will be assigned to your account. \n7.After all necessary documentation is checked and approved by Vert, you will receive an email \nconfirming your account registration. You'll then have access to your account in the Vert Chauffeur App. \n8.To start accepting jobs as a Vert Chauffeur, you'll need to enter your payment information, including Sort Code, Account Number, and long card number, so we can process payouts to your account. ",
  },
  {
    question: 'Where can I see my past, upcoming, and new trips?',
    answer:
      '1. Tap into the main menu of the app\n2. Select “Your Trips”\n3. Select either the “Past”, “Scheduled” or “New” trip list',
  },
  {
    question: 'Can I cancel a ride?',
    answer:
      'We understand that sometimes things do not work as planned and that you may need to cancel a ride. You can cancel from your app, however, depending on the situation a cancellation fee may apply. If you want to know more about our cancellation policy, please check the Driver Terms and Conditions in your App under the tab Legal/Terms and Conditions. ',
  },
  {
    question: 'When can I report a rider?',
    answer: `Your safety is of utmost importance to us. Therefore, we've streamlined the process for you to share your ride experience and report any concerns about a fellow rider if you ever feel unsafe during a trip. Here's how you can do it: \n\n1. At the end of your ride, utilize the "Safety" rating scale.\n2. Choose the "Report Rider" option.\n3. Complete the report user form that you'll be directed to, providing as many details as possible regarding the circumstances that led to your report.
      \nIt's crucial to understand that this is a serious procedure and should only be used in situations where your safety has genuinely been compromised. In such cases, both your account and the rider's account will be temporarily suspended while further verifications are conducted. Additionally, we will promptly report any dangerous or inappropriate behaviour to the appropriate authorities. Your safety remains our top priority. 
      `,
  },
  {
    question: 'What occurs when a rider reports you?',
    answer: `If a rider reports you, we will carefully examine the concerns outlined in the rider's report form. It's essential to emphasize that this is a highly significant procedure, reserved for situations where there has been a genuine compromise of safety. In such instances:\n1. Your account, as well as the rider's account, will be temporarily suspended while additional verifications are conducted.\n2. Any incidents involving dangerous or inappropriate behaviour will be promptly reported to the police.\n\nWe take reports seriously to ensure the safety and security of all our users.
    `,
  },
  {
    question: 'What is the Emergency/Panic button?',
    answer:
      'At Vert, we are dedicated to collaborating with our users and stakeholders to elevate the safety of everyone involved in rides facilitated by our platform. ',
  },
];

const covidQuestions = [
  {
    question:
      'What is Vert doing to help customers and chauffeurs to stay safe?',
    answer:
      'In between each ride, our chauffeurs thoroughly disinfect the vehicles\n\nIt is now not compulsory to wear masks but if you require for the chauffeur to wear mask please specify or simply ask the chauffeur to do so.\n\nGreeting clients with a slight bow instead of a handshake\n\nWe provide a complementary mask in case you require one\n\nWe have placed hand sanitizer in each vehicle.\n\nWe have temporarily suspended water, wipes, newspapers, and magazines. If you require anything from above please specify at the time of booking.\n\nWe have reduced the maximum number of guests per vehicle to ensure that the front passenger seat remains free, providing maximum social distancing in vehicles. No more than two clients in the vehicles\n\nWe also ask all our clients who are showing any symptoms or have tested positive not to book a Vert ride',
  },
  {
    question:
      'What happens if a Chauffeur or Vert employee is directly affected or tested positive for coronavirus (COVID-19)?',
    answer:
      'Clients, chauffeurs, and employees, your safety is our top priority. We require any employee or chauffeur who tests positive to inform Vert management immediately.\n\nOnce informed, we will notify those who were in direct contact with the affected person for the previous two weeks. Any chauffeurs who suspect they may be sick will not perform any rides. Any chauffeur who tests positive for coronavirus may not perform Vert rides for 14 days or until receiving a doctor’s permission.',
  },
  {
    question: 'Am I supposed to wear a face mask during the ride?',
    answer:
      'Wearing masks it is now not compulsory. Should you want to wear one during your trip please feel free to wear one.',
  },
  {
    question:
      'Can chauffeurs assist guests with luggage and other personal effects?',
    answer:
      'Yes, our chauffeurs will continue to provide the same personal assistance with luggage and other belongings. If you prefer to handle your luggage personally, please inform the chauffeur. If the chauffeur handles your luggage, it will be wiped down before handing it back to you. Alternatively, the chauffeur can open and close the trunk so only you can touch your belongings.',
  },
  {
    question: 'Are there partition screens in the cars?',
    answer:
      'It is now not mandatory to wear a face mask. Should you wish to wear one you can do so and you can require the chauffeur to wear one as well. Face masks have been scientifically proven to be the most important safety measure against COVID.\n\nPartition screens are optional unless local regulations require them. Their efficacy remains unproven, and they add more risk in the event of an accident. Guests and chauffeurs can choose to wear a mask, whether or not vehicles have partition screens.',
  },
];

const FAQ = () => {
  const [questions, setQuestions] = useState([]);
  const [currentCategory, setCurrentCategory] = useState('Rider');
  const [currentQuestion, setCurrentQuestion] = useState(null);

  // Load faqs
  // const faqsQueryRes = useQuery(GET_FAQ, {
  //   context: { clientName: 'strapi' },

  //   fetchPolicy: 'cache-first',
  // });

  // let FAQS = [];

  // if (!faqsQueryRes.loading) {
  //   FAQS = faqsQueryRes.data.lists.data.map(
  //     (list: { attributes: { entities: any } }) => list.attributes.entities
  //   );
  // }

  useEffect(() => {
    setQuestions(riderQuestions);
  }, []);

  const handleLinkClick = (event) => {
    event.preventDefault();
    const url = event.target.href;

    const searchString = decodeURIComponent(url.split('#')[1]);
    const index = questions.findIndex(
      (question) => question.attributes.question === searchString
    );

    if (index !== currentQuestion) {
      setCurrentQuestion(index);
    }
  };

  const [isLargerThan728] = useMediaQuery('(min-width: 728px)');

  let seo = {};

  return (
    <Layout withAppNavBar={false}>
      <Seo seo={seo} />
      <Flex
        as="section"
        direction="column"
        justifyContent="center"
        alignItems="center"
        py={20}
        px={isLargerThan728 ? 20 : 3}
      >
        <Text
          as="h1"
          className={roboto.className}
          py={10}
          textAlign="center"
          fontSize="5xl"
        >
          Frequently Asked Questions
        </Text>

        <Box as="nav" w="100%" py={5}>
          <Box maxW={720} margin="1rem auto">
            <Tabs
              onChange={(index) => {
                if (index === 0) {
                  setCurrentCategory('Rider');
                  setQuestions(riderQuestions);
                }
                if (index === 1) {
                  setCurrentCategory('Driver');
                  setQuestions(driverQuestions);
                }
                if (index === 2) {
                  setCurrentCategory('Covid-19');
                  setQuestions(covidQuestions);
                }
              }}
            >
              <TabList>
                <Tab color="black">Rider</Tab>
                <Tab color="black">Chauffeur</Tab>
                <Tab color="black">Covid-19</Tab>
              </TabList>

              <TabPanels>
                {[riderQuestions, driverQuestions, covidQuestions].map(
                  (categoryQuestions, tabIndex) => (
                    <TabPanel key={tabIndex}>
                      <Accordion allowToggle index={currentQuestion}>
                        {categoryQuestions.map((item, index) => (
                          <AccordionItem key={index}>
                            <h2>
                              <AccordionButton
                                onClick={() => {
                                  if (index === currentQuestion) {
                                    setCurrentQuestion(null);
                                  } else {
                                    setCurrentQuestion(index);
                                  }
                                }}
                              >
                                <Box
                                  as="span"
                                  flex="1"
                                  textAlign="left"
                                  fontSize="0.9rem"
                                  fontWeight="600"
                                >
                                  {item.question}
                                </Box>
                                <AccordionIcon />
                              </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                              <ChakraMarkdown
                                content={item.answer}
                                onLinkClick={handleLinkClick}
                              />
                            </AccordionPanel>
                          </AccordionItem>
                        ))}
                      </Accordion>
                    </TabPanel>
                  )
                )}
              </TabPanels>
            </Tabs>
          </Box>
        </Box>
      </Flex>
    </Layout>
  );
};

export default FAQ;
